// path: frontend/src/components/menus/projectMenu.js
/**
 * Состав контекстного меню проекта. Единственный источник для
 * Kanban-карточки и списковой карточки.
 *
 * RBAC-флаги — только с сервера:
 *   - project.permissions.allowedStatuses — переходы (canChangeProjectStatus);
 *   - project.permissions.canManageAccess — «Доступ» (canEditProjectFields);
 *   - capabilities.createProject — «Копировать» / «В шаблон».
 *
 * Коллбэки onMove / onCopy / onMakeTemplate / onOpenAccess — опциональные:
 * пункт, для которого коллбэк не передан, не появляется.
 *
 * Подтверждение для closed/cancelled — не здесь, а в onMove
 * (ProjectsView.handleMoveProject): единый обработчик для клика в меню и
 * drag-and-drop в канбане.
 */
import { PROJECT_STATUSES } from "../../utils/constants";
import { ICONS } from "../iconsData";

export function buildProjectMenu({
  project,
  capabilities,
  openProject,
  onMove,
  onCopy,
  onMakeTemplate,
  onOpenAccess,
}) {
  const isClosed =
    project.status === "closed" || project.status === "cancelled";

  const serverStatuses = Array.isArray(project.permissions?.allowedStatuses)
    ? project.permissions.allowedStatuses
    : [];

  const canCreate = Boolean(capabilities?.createProject);
  const canManageAccess = Boolean(project.permissions?.canManageAccess);

  const canCopy = !!onCopy && canCreate;
  const canMakeTemplate = !!onMakeTemplate && canCreate;
  const canOpenAccess = !!onOpenAccess && !isClosed && canManageAccess;

  const statusChoices =
    onMove && !isClosed
      ? serverStatuses.filter((s) => s !== project.status)
      : [];

  const hasStatusBlock = statusChoices.length > 0;
  const hasActionsBlock = canCopy || canMakeTemplate || canOpenAccess;

  return [
    {
      id: "open",
      label: "Открыть проект",
      icon: ICONS.eye,
      onClick: () => openProject(project.id),
    },
    hasStatusBlock && { type: "divider" },
    hasStatusBlock && { type: "header", label: "Перевести в статус" },
    ...statusChoices.map((s) => ({
      id: `status-${s}`,
      label: PROJECT_STATUSES[s] || s,
      onClick: () => onMove(project.id, s),
    })),
    hasActionsBlock && { type: "divider" },
    canCopy && {
      id: "copy",
      label: "Копировать",
      icon: ICONS.copy,
      onClick: () => onCopy(project.id),
    },
    canMakeTemplate && {
      id: "template",
      label: "В шаблон",
      icon: ICONS.star,
      onClick: () => onMakeTemplate(project.id),
    },
    canOpenAccess && {
      id: "access",
      label: "Доступ",
      icon: ICONS.shield,
      onClick: () => onOpenAccess(project.id),
    },
  ].filter(Boolean);
}
